import Vue from "vue";
let crypto = require("crypto-js");
let moment = require("moment");
import { objectToQuery } from "@/lib/objectToQuery.js";
import { pdfExport, csvExport } from "@/lib/download.js";
import { formatKeysToPascalCase } from "../lib/formatKeysToPascalCase";
import { stripAllIds } from "@/lib/arrayManipulation.js";
import { formatKeysToCamelCase, formatKeysToSnakeCase } from "../lib/utils";

export default {
  //general
  notify(context, { e, str, s }) {
    let phrase = str ? str : "";
    let options = "";
    if (s) {
      options = {
        group: "notifications-default",
        type: "success text-white",
        title: "Success",
        text: s.body && s.body.message ? s.body.message : phrase,
      };
    } else {
      options = {
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: e.body && e.body.message ? e.body.message : phrase,
      };
    }
    Vue.notify(options);
  },

  // Generate Authenticator for API
  fetchApiAuth({ commit }) {
    // Return a promise    // move to enviroment vatriable
    return new Promise((resolve) => {
      let customerReference = "techbank-" + moment().format("x");
      let userId = process.env.USER_ID;
      let userSecret = process.env.USER_SECRET;

      // Generate hash
      let hash = crypto
        .SHA256(customerReference + userId + userSecret)
        .toString();
      // store hash
      commit("setApiAuth", hash);
      // resolve promise
      resolve();
    });
  },

  getTransactionDetail({ commit }, payload) {
    commit("setSettlementTransactionDetails", { loading: true });

    Vue.http
      .get(`dashboard/transactions?unique_reference=${payload.id}`)
      .then((res) => {
        commit("setSettlementTransactionDetails", {
          ...res.body.data,
          loading: false,
        });
      });
  },

  setSettlementScheduleStatus({ commit, dispatch }, payload) {
    const url = `dashboard/admin/settlements/update`;

    Vue.http
      .put(url, {
        status: payload.status.toString().toUpperCase(),
        settlement_id: payload.id,
      })
      .then((res) => {
        const isSuccess = res.data.status === "success";

        Vue.notify({
          group: "notifications-default",
          type: `${isSuccess ? "success" : "error"} text-white`,
          title: isSuccess ? "Success" : "Error",
          text: res.data.message,
        });
        // payload.id = payload.ref;
        // dispatch("getSettlementDetails", payload);
        window.location.reload();
      });
  },
  setSettlementDetails({ commit, state }, payload) {
    commit("setSettlementDetail", payload);
  },
  getSettlementDetails({ commit, state }, payload) {
    const id = payload.id;

    delete payload.id;
    // tableLoading
    commit("setSettlementDetail", {
      ...state.settlementDetail,
      tableLoading: true,
    });
    //      .get(`dashboard/settlements/${id}/transactions${objectToQuery(payload)}`)
    let url = `dashboard/admin/settlements/single/${id}${objectToQuery(
      payload
    )}`;
    if (payload.default) {
      url = `dashboard/settlements/${id}/transactions${objectToQuery(payload)}`;
    }
    Vue.http.get(url).then((res) => {
      commit("setSettlementDetail", {
        ...res.body.data,
        loading: false,
        tableLoading: false,
      });
    });
  },

  getSettlementBatchDetails({ commit, state }, payload) {
    const id = payload.id;

    delete payload.id;

    Vue.http
      .get(`dashboard/admin/settlements/single/${id}${objectToQuery(payload)}`)
      .then((res) => {
        console.log(res.body.data);
        const data = Object.assign({}, res.body.data, {
          tableLoading: !!!res.body.data,
        });
        commit("setSettlementBatchDetail", data);
      });
  },

  retrySettlementBatch({ commit, state }, payload) {
    const type = payload.all ? "?type=batch" : "?type=batch";
    let url = `dashboard/admin/settlements/retry_settlement/bulk${type}`;
    if (payload.approval) {
      url = `dashboard/admin/settlements/process_settlement/bulk${type}`;
    }
    const request =
      payload.all && payload.parent_settlement_id
        ? {
            parent_settlement_id: payload.parent_settlement_id,
            action: "all",
          }
        : {
            settlement_references: payload.settlement_references,
          };
    Vue.http
      .put(url, request)
      .then((res) => {
        Vue.notify({
          group: "notifications-default",
          type: "warning text-white",
          title: `Settlement ${payload.approval ? "approval" : "retry"}`,
          text: `Settlement ${
            payload.approval ? "approval" : "retry"
          } has been initiated and waiting.`,
        });
        // if (payload.reload) {
        //   setTimeout(() =>{
        commit("getSettlementTranches", {
          reference: payload.settlement_references[0],
        });
        //   }, 1000)
        // }
      })
      .catch((err) => {
        Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: `Unable to ${
            payload.approval ? "approve" : "retry"
          }  settlement`,
          text: `Unable to ${
            payload.approval ? "approve" : "retry"
          }  settlement`,
        });
      });
  },
  retrySettlement({ commit, state }, payload) {
    const type = payload.type ? "?type=batch" : "";
    console.log({ payload });
    let url = `dashboard/admin/settlements/${payload.settlement_reference}/retry_settlement${type}`;
    if (payload.approval) {
      url = `dashboard/admin/settlements/${payload.settlement_reference}/process_settlement${type}`;
    }
    Vue.http
      .put(url)

      .then((res) => {
        Vue.notify({
          group: "notifications-default",
          type: "warning text-white",
          title: `Settlement ${payload.approval ? "approval" : "retry"}`,
          text: `Settlement ${
            payload.approval ? "approval" : "retry"
          } has been initiated and waiting.`,
        });
      })
      .catch((err) => {
        console.log(err, err.body.message);
        Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: `Unable to ${
            payload.approval ? "approve" : "retry"
          }  settlement`,
          text:
            err.body.message ||
            err.message ||
            `Unable to ${payload.approval ? "approve" : "retry"}  settlement`,
        });
      });
  },

  settlementProcessing({ commit }, { rows }) {
    return new Promise((resolve, reject) => {
      // make api call for schedulement processing
      const url = `dashboard/admin/settlements`;
      const requestBody = {
        transaction_ids: rows,
      };
      Vue.http
        .post(url, requestBody)
        .then((result) => {
          // Notify user
          Vue.notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Settlement schedule generated",
            text: "Settlement schedule has been successfully generated.",
          });
          // Route to pending schedule.
          commit("setRowSelected", { type: "none" });
          resolve(result);
        })
        .catch((error) => {
          const errMsg = error.message || error;
          Vue.notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Unable to generate settlement schedule",
            text: errMsg,
          });
          reject(error);
        });
    });
  },

  getSettlementTransactions({ commit }, payload) {
    commit("setSettlementTransactions", { loading: true });

    const url = `dashboard/admin/settlements/transactions/unsettled${objectToQuery(
      payload
    )}`;

    Vue.http.get(url).then((res) => {
      commit("setSettlementTransactions", { ...res.data.data, loading: false });
    });
  },

  selectAllUnsettledSettlementTransactions({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let query = objectToQuery(payload);
      query =
        String(query).trim() === ""
          ? `?download=true&id_only=true`
          : `${query}&download=true&id_only=true`;
      const url = `dashboard/admin/settlements/transactions/unsettled${query}`;

      Vue.http
        .get(url)
        .then((res) => {
          const ids = res.data.data.unsetlled_transactions;
          const rows = Object.values(ids).map((value) => value.id);
          commit("setSelectAllRows", { rows });
          resolve(true);
        })
        .catch((error) => {
          // console.log(error, "<== CHECKALL ERRORS");
          // reject(error);
          Vue.notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: "Unable to select all, please try again",
          });
        });
    });
  },

  getSettlementList({ commit }, payload) {
    commit("setSettlements", { loading: true });

    Vue.http
      .get(`dashboard/admin/settlements${objectToQuery(payload)}`)
      .then((res) => {
        commit("setSettlements", { ...res.data.data, loading: false });
      });
  },

  download({ commit }, { downloadType, url, key, filter, fileName }) {
    Vue.notify({
      group: "notifications-default",
      type: "info text-white",
      title: "Info",
      text: "Downloading, please wait...",
    });
    console.log({ res: "dsfsd" });

    Vue.http
      .get(`${url}${objectToQuery(filter)}`)
      .then((res) => {
        console.log({ res });
        const data = key ? res.data.data[key] : res.data.data;
        if (data) {
          switch (String(downloadType).toLowerCase().trim()) {
            case "pdf":
              pdfExport(formatKeysToPascalCase(data), fileName);
              break;
            case "csv":
              csvExport(formatKeysToPascalCase(data), fileName);
              break;
            default:
              break;
          }
        }
      })
      .catch((error) => {
        // console.log(error, 'err');
        const { body = {}, message } = error;
        const { status, errors = {} } = body;
        // console.log("Download Error =>", status);
        if (status == 401) {
          // TODO: log out.
          errors.message = "Session timeout. Please log back in";
        }
        Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Download Error",
          text: message
            ? message
            : errors.message
            ? errors.message
            : "An unknown error occured. please try again",
        });
      });
  },

  getDirectDebitTransactions() {
    Vue.http.get("dashboard/merchants").then((response) => {});
  },
  login({ commit }, request) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("admin/merchants/login", request)
        .then((response) => {
          // Update state and store in localstorage
          commit("setUserDetails", response.body.data);
          commit("setUserRole", response.body.data.role);
          window.localStorage.setItem(
            "gelato",
            JSON.stringify(response.body.data)
          );

          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchProfile({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("dashboard/merchants")
        .then((response) => {
          let meta = {
            // Business Information
            business_currency: "",
            rc_number: "",
            business_address: "",
            support_number: "",
            support_email: "",
            // Bank Information
            bank_name: "",
            bvn: "",
          };

          let updatedDetails;

          // check if meta is null or not
          if (response.body.data.merchant.meta !== null) {
            // Update state and store in localstorage
            updatedDetails = {
              token: state.userDetails.token,
              permissions: response.body.data.permissions,
              ...response.body.data.merchant,
            };
          } else {
            // Update state and store in localstorage
            updatedDetails = {
              token: state.userDetails.token,
              permissions: response.body.data.permissions,
              ...response.body.data.merchant,
            };

            // Update the meta for the other fields
            updatedDetails.meta = meta;
          }

          commit("setUserDetails", updatedDetails);

          if (payload.reload) {
            window.location.reload();
          }

          window.localStorage.setItem("gelato", JSON.stringify(updatedDetails));
          resolve(updatedDetails);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  editProfile({ commit }, request) {
    return new Promise((resolve, reject) => {
      // If request is available means user is trying to modify values
      Vue.http
        .put("dashboard/merchants", request)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateMode({ commit }, request) {
    return new Promise((resolve, reject) => {
      commit("setMode", request);
      window.localStorage.setItem("mode", request);
      setTimeout(() => {
        resolve();
      }, 1000);
    });
  },

  fetchBankName({ commit }) {
    Vue.http
      .get("banks/look_up")
      .then((response) => {
        // commit response
        commit("setBankName", response.body.data);
        // save response in localstorage
        window.localStorage.setItem(
          "bankListNames",
          JSON.stringify(response.body.data)
        );
      })
      .catch((error) => {});
  },

  fetchBankList({ commit }) {
    Vue.http
      .get("metadata/banks/")
      .then((response) => {
        // commit response
        commit("setBankList", response.body.data);
        // save response in localstorage
        window.localStorage.setItem(
          "banks",
          JSON.stringify(response.body.data)
        );
      })
      .catch((error) => {});
  },

  fetchSubAccounts({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("dashboard/subaccounts")
        .then((response) => {
          // commit subaccounts
          commit("setSubAccounts", response.body.data.subaccounts);
          // return the response.
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  downloadDirectDebitMandateList({ commit }, { downloadType, filter }) {
    Vue.notify({
      group: "notifications-default",
      type: "info text-white",
      title: "Info",
      text: "Downloading, please wait...",
    });
    const url = `${
      process.env.VUE_APP_DD_API_URL
    }/admin/mandates${objectToQuery(filter)}`;
    Vue.http
      .get(url)
      .then((response) => {
        // console.log(response);
        const { body = { rows: [] } } = response.data;
        if (body.rows.length > 0) {
          switch (String(downloadType).toLowerCase().trim()) {
            case "pdf":
              pdfExport(formatKeysToPascalCase(body.rows));
              break;
            case "csv":
              csvExport(formatKeysToPascalCase(body.rows));
              break;
            default:
              break;
          }
        } else {
          throw new Error(
            "Nothing to export. Please review your filter try again"
          );
        }
      })
      .catch((error) => {
        const { body = {}, message } = error;
        const { status, errors = {} } = body;
        // console.log("Download Error =>", status);
        if (status == 401) {
          // TODO: log out.
          errors.message = "Session timeout. Please log back in";
        }
        Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Download Error",
          text: message
            ? message
            : errors.message
            ? errors.message
            : "An unknown error occured. please try again",
        });
      });
  },
  async getPayoutDashboard({ commit }, payload) {
    try {
      commit("setPayoutDashboard", { loading: true });

      const response = await Vue.http.get(
        `dashboard/merchant/payouts/summary${objectToQuery(payload)}`
      );

      commit("setPayoutDashboard", {
        ...response.body.data,
        loading: false,
      });
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: "Unable to select all, please try again",
      });
    }
  },
  async getPayoutDetails({ commit }, payload) {
    const { id, type, ...rest } = payload;

    let url;

    commit("setPayoutDetails", {
      loading: true,
    });

    if (type === "payouts") {
      url = `dashboard/admin/${id}/payouts${objectToQuery(rest)}`;
    } else {
      url = `dashboard/admin/${id}/payouts/history${objectToQuery(rest)}`;
    }

    const response = await Vue.http.get(url);

    commit("setPayoutDetails", {
      ...response.body,
      loading: false,
      type,
      page_info: {
        total: 1,
        total_pages: 1,
        current_page: 1,
      },
    });
  },
  async getSinglePayoutDetails({ commit }, payload) {
    try {
      const { id, reference } = payload;

      commit("setSingleDetails", { loading: true });

      const response = await Vue.http.get(
        `dashboard/admin/${id}/payouts?unique_reference=${reference}`
      );

      commit("setSingleDetails", {
        ...response.body.data.payout_transactions[0],
        loading: false,
      });
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });
    }
  },
  async getRoutingRules({ commit, state }) {
    try {
      commit("setRoutingRules", { loading: true, ...state.routingRules });

      const response = await Vue.http.get(`admin/routingrules`);

      commit("setRoutingRules", {
        loading: false,
        rules: response.body.data.routing_rules,
      });
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });
    }
  },
  async saveRoutingRules({ commit, dispatch, state }, payload) {
    try {
      commit("setRoutingRules", { loading: true, ...state.routingRules });

      const response = await Vue.http.post(`admin/routingrules`, {
        rules: stripAllIds(payload),
      });

      Vue.notify({
        group: "notifications-default",
        type: "success text-white",
        title: "Routing rule created.",
        text: response.body.data.message,
      });

      dispatch("getRoutingRules");
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });

      dispatch("getRoutingRules");
    }
  },
  async getMerchantRoutingRules({ commit }, payload) {
    try {
      const response = await Vue.http.get(
        `admin/merchant/rules${objectToQuery(payload)}`
      );

      if (payload.merchant_id) {
        commit("setMerchantSpecificRules", {
          ...response.body.data,
          loading: false,
        });
      } else {
        commit("setMerchantRoutingRules", {
          ...response.body.data,
          loading: false,
        });
      }
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
      });
    }
  },

  async addRule({ commit }, payload) {
    try {
      const res = await Vue.http.post(
        `${process.env.VUE_APP_DD_API_URL}/admin/mandates/config`,
        payload
      );

      Vue.notify({
        group: "notifications-default",
        type: "success text-white",
        title: "Rule created",
        text: res.body.message,
      });
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });
    }
  },

  async setSpecificRoutingRules({ commit, state }, payload) {
    try {
      commit("setMerchantRoutingRules", {
        ...state.merchantRoutingRules,
        isSettingMerchantSpecificRule: true,
      });

      const response = await Vue.http.post(
        `admin/merchant/rules/${payload.merchant_id}`,
        {
          bank_code: payload.bank_code,
          rule_type: "Specific",
          status: "ACTIVE",
        }
      );

      commit("setMerchantRoutingRules", {
        ...state.merchantRoutingRules,
        isSettingMerchantSpecificRule: false,
      });

      Vue.notify({
        group: "notifications-default",
        type: "success text-white",
        title: "Merchant Specific Routing bank.",
        text: response.body.message,
      });
    } catch (err) {
      commit("setMerchantRoutingRules", {
        ...state.merchantRoutingRules,
        isSettingMerchantSpecificRule: false,
      });

      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });
    }
  },

  async saveCollectionAccount({ commit }, payload) {
    try {
      commit("setDefaultCollectionAccount", {
        isSettingDefaultCollectionAccount: true,
      });

      const response = await Vue.http.post(`admin/defaultbank`, payload);

      commit("setDefaultCollectionAccount", {
        isSettingDefaultCollectionAccount: false,
      });

      Vue.notify({
        group: "notifications-default",
        type: "success text-white",
        title: "Merchant Specific Routing bank.",
        text: response.body.message,
      });
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });
    }
  },

  async getExistingFees({ commit }, payload) {
    try {
      commit("setFees", { loading: true });

      const response = await Vue.http.get(
        `admin/fees${objectToQuery(payload)}`
      );

      commit("setFees", { ...response.body.data, loading: false });
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });
    }
  },
  async getDirectDebitRules({ commit }, payload) {
    try {
      let response;

      if (payload) {
        response = await Vue.http.get(
          `${process.env.VUE_APP_DD_API_URL}/admin/mandates/merchant/config/${payload.id}`
        );
      } else {
        response = await Vue.http.get(
          `${process.env.VUE_APP_DD_API_URL}/admin/mandates/config/limit`
        );
      }

      commit("setRules", { rules: response.body.body, loading: false });
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });

      commit("setRules", { rules: [], loading: false });
    }
  },
  async getTransactionTypes({ commit }) {
    try {
      const response = await Vue.http.get(`admin/get_transaction_types`);

      commit("setTransactionTypes", response.body.data);
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });

      commit("setTransactionTypes", []);
    }
  },

  async getSettlementTranches({ commit }, payload) {
    try {
      const response = await Vue.http.get(
        `dashboard/admin/settlement_batches/${payload.reference}?page=${
          payload.page || 1
        }`
      );

      commit("setSettlementTranches", {
        ...response.body.data,
        loading: false,
      });
    } catch (err) {
      console.log(err);
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: "We are unable to process your request try again later.",
      });
    }
  },

  async getSettlementRetries({ commit }, payload) {
    try {
      const response = await Vue.http.get(
        `dashboard/admin/settlement_retries/${payload.reference}?${
          payload.type ? "type=" + payload.type + "&" : ""
        }page=${payload.page || 1}`
      );

      commit("setSettlementRetries", { ...response.body.data, loading: false });
    } catch (err) {
      console.log(err);
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: "We are unable to process your request try again later.",
      });
    }
  },

  //  transfers
  async getCollectionAccounts() {
    try {
      const response = await Vue.http.get("admin/transfer/accounts");
      if (response.body.data) {
        return response.body.data.map((account) =>
          formatKeysToCamelCase(account)
        );
      }
    } catch (e) {
      this.dispatch("notify", {
        e,
        str: "Couldn't get accounts, Please check your network and refresh the page",
      });
    }
  },

  doBankEnquiry(commit, { nuban, bank_code }) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("dashboard/nuban/enquiry", {
          nuban,
          bank_code,
        })
        .then((response) => {
          // return the response.
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async getTransferRequests(context, payload) {
    try {
      let generatedQuery = objectToQuery(payload);
      const response = await Vue.http.get(
        `admin/transfer/request${generatedQuery}`
      );
      if (response.body.data) {
        let data = response.body.data.admin_transfers.map((transfer) =>
          formatKeysToCamelCase(transfer)
        );

        return {
          data,
          pageInfo: response.body.data.page_info,
        };
      }
    } catch (e) {
      this.dispatch("notify", {
        e,
        str: "Couldn't get transfers, Please check your network and refresh the page",
      });
    }
  },

  async submitTransferApprovalRequest(context, payload) {
    try {
      const response = await Vue.http.post(
        "admin/transfer/request",
        formatKeysToSnakeCase(payload)
      );
      if (response.body.data) {
        return response.body.data;
      }
    } catch (e) {
      this.dispatch("notify", {
        e,
        str: "Couldn't submit request, Please check your network and refresh the page",
      });
    }
  },

  async handleRequest(context, { data, action, totp_code }) {
    try {
      if(totp_code) data.totp_code = totp_code;
      const response = await Vue.http.put(
        `admin/transfer/${data.reference}/${action}`,
        data
      );
      if (response.body.data) {
        return response.body.data;
      }
    } catch (e) {
      this.dispatch("notify", {
        e,
        str: `Couldn't ${action} request , Please check your network and refresh the page`,
      });
    }
  },

  async getTransferDetails(context, reference) {
    try {
      const response = await Vue.http.get(
        `admin/transfer/request/${reference}`
      );
      return formatKeysToCamelCase(response.body.data);
    } catch (e) {
      this.dispatch("notify", {
        e,
        str: "Couldn't fetch request details , Please check your network and refresh the page",
      });
    }
  },

  async fetchAudit(context, value) {
    try {
      const response = await Vue.http.get(
        `dashboard/audits?entity_id=${value}`
      );
      return response.body.data.audits;
    } catch (e) {
      this.dispatch("notify", {
        e,
        str: "Couldn't fetch audits , Please check your network and refresh the page",
      });
    }
  },

  async sendOtp(context, payload) {
    try {
      const response = await Vue.http.post("admin/transfer/OTP", payload);
      return response.body.data;
    } catch (e) {
      this.dispatch("notify", {
        e,
        str: "Couldn't send OTP , Please check your network and refresh the page",
      });
    }
  },

  resendCallback(context, payload) {
    Vue.http.post(`admin/ping/${payload}`);
    Vue.notify({
      group: "notifications-default",
      type: "success text-white",
      title: "Success",
      text: "Webhooks sent",
    });
  },

  // beneficiaries
  async fetchBeneficiaries({ commit }, payload) {
    try {
      const url = `dashboard/beneficiaries${objectToQuery(payload)}`;

      commit("setBeneficiaries", { loading: true });

      const res = await Vue.http.get(`${url}`);
      commit("setBeneficiaries", { ...res.body.data, loading: false });
      return res.body.data;
    } catch (e) {
      return null;
    }
  },

  async fetchPriorityConfigurationList({ commit }) {
    commit("setPriorityConfigurationList", {
      loading: true,
    });
    try {
      const response = await Vue.http.get(
        "dashboard/admin/payout_priority_config"
      );
      commit("setPriorityConfigurationList", response.body);
    } catch (e) {
      commit("setPriorityConfigurationList", {
        loading: false,
      });
    }
  },
  async createUpdatePriorityConfigurationList({ commit }, payload) {
    if (payload.update) {
      return Vue.http.put("dashboard/admin/payout_priority_config", payload);
    }
    return Vue.http.post("dashboard/admin/payout_priority_config", payload);
  },
  setCustomMetaOptions({ commit }, payload) {
    commit("setCustomMetaOptions", payload);
  },

  // statements and reconcilliation
  async deleteStatement(context, code) {
    try {
      const res = await Vue.http.delete(
        `admin/statement/delete?batch_code=${code}`
      );
      return [res, null];
    } catch (e) {
      return [null, e];
    }
  },

  //  statement reconciliation
  async createSingleStatement(context, payload) {
    try {
      const res = await Vue.http.post("admin/statement", payload);
      return [res.body, null];
    } catch (e) {
      return [null, e.body.message];
    }
  },

  async getMerchantAccess({ commit }, merchantId) {
    try {
      const res = await Vue.http.get(
        `dashboard/admin/merchant_service_access/?merchantId=${merchantId}`
      );
      const serviceAccesses = res.data.data;
      if (serviceAccesses.length > 0) {
        const remappedAccess = serviceAccesses.reduce((acc, val) => {
          acc[val.transaction_type_id] = val.admin_enabled;
          return acc;
        }, {});
        commit("setMerchantAccess", { merchantId, value: remappedAccess });
      } else {
        commit("setMerchantAccess", { merchantId, value: null });
      }
    } catch (e) {
      console.error(
        "could not fetch merchant service access for merchant ",
        merchantId
      );
    }
  },

  async grantMerchantAccess(
    { commit },
    { merchantId, transactionTypeId, adminEnabled, merchant_enabled }
  ) {
    // commit("setMerchantAccess", { grantDefaultAccess: true });
    const requestData = {
      merchantId: merchantId,
      transactionTypeId: transactionTypeId,
      adminEnabled: adminEnabled,
      merchant_enabled: merchant_enabled,
    };
    const url = process.env.VUE_APP_API_URL;
    const res = await Vue.http.patch(
      `dashboard/admin/merchant_service_access`,
      requestData
    );
    // console.log(res)
  },

  async grantQRMerchantAccess(
    { commit },
    { merchantId }
  ) {
    // commit("setMerchantAccess", { grantDefaultAccess: true });
    const requestData = {
      merchantId: merchantId,
    };
    const url = process.env.VUE_APP_API_URL;
    const res = await Vue.http.post(
      `admin/nqr/merchant/activate`,
      requestData
    );
    // console.log(res)
  },

  async adminPlaceLien({ commit }, { merchantId, amount, reason }) {
    try {
      const res = await Vue.http.post(`dashboard/admin/lien/${merchantId}`, {
        amount,
        reason,
      });
      commit("setMerchantActiveLien", { amount, reason });
      Vue.notify({
        group: "notifications-default",
        type: "success text-white",
        title: "Lien created",
        text: res.body.message,
      });
    } catch (err) {
      console.log({ err });
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });
    }
  },

  async adminRemoveLien({ commit }, { merchantId }) {
    try {
      const res = await Vue.http.put(`dashboard/admin/lien/${merchantId}`, {});
      commit("setMerchantActiveLien", null);
      Vue.notify({
        group: "notifications-default",
        type: "success text-white",
        title: "Lien removed",
        text: res.body.message,
      });
    } catch (err) {
      Vue.notify({
        group: "notifications-default",
        type: "error text-white",
        title: "Error",
        text: err.body.message,
      });
    }
  },

  async listMerchantLien({ commit }, merchantId) {
    try {
      const res = await Vue.http.get(
        `dashboard/admin/lien/?is_active=true&merchantId=${merchantId}`
      );
      if (res.data.data.length > 0) {
        commit("setMerchantActiveLien", { ...res.data.data[0] });
      }
    } catch (err) {
      return err;
    }
  },

  async listAllLien({ commit }) {
    try {
      const res = await Vue.http.get(`dashboard/admin/lien/?is_active=true`);
      return res;
    } catch (err) {
      return err;
    }
  },

  async generateAccountStatement(state, payload) {
    try {
      const url = `admin/dashboard/merchants/account-statement`;
      const res = await Vue.http.post(`${url}`, payload);
      this.dispatch("notify", {
        s: res,
        str: "Account Statement would be sent to your email",
      });
      return res.body.data;
    } catch (e) {
      this.dispatch("notify", {
        e,
        str: e.body.message,
      });
      return null;
    }
  },
};
